import { useState, useEffect, useCallback } from "react";
import DraggableDualList from "../DraggableDualList/DraggableDualList";
import { useAuth } from "../../contexts/auth";
import NotificationsService from "../../services/NotificationsService";
import { NotificationTargetType } from "../../constants/notifications.constants";

function makeItemId(category) {
   return `${category.id}`;
}

function buildTree(allCategories, selectedCategories, includeSelected) {
   const categoryMap = new Map();

   for (const category of allCategories) {
      const belongsToCategory = selectedCategories?.find(
         (ca) => ca.id === category.id
      );

      const shouldInclude = includeSelected ? !!belongsToCategory : !belongsToCategory;
      if (!shouldInclude) continue;

      const itemId = makeItemId(category);
      categoryMap.set(itemId, {
         id: itemId,
         type: "item",
         label: category.categoryName,
         originalId: category.id,
         relationId: belongsToCategory?.id,
      });
   }

   return Array.from(categoryMap.values());
}
function flattenSelectedItems(rightTree) {
   const selected = [];
   for (const node of rightTree) {
      const items = node.type === "group" ? node.children : [node];
      for (const item of items) {
         if (item.type === "item") {
            selected.push({
               id: item.id,
               relationId: item.relationId,
               originalId: item.originalId,
               value: item.id,
               label: item.label,
            });
         }
      }
   }
   return selected;
}

export function WebhookCategoriesDDL({ categories, onChangeList }) {
   const { user } = useAuth();
   const [allCategories, setAllCategories] = useState([]);
   const [initialLeft, setInitialLeft] = useState([]);
   const [initialRight, setInitialRight] = useState([]);
   const [ready, setReady] = useState(false);

   useEffect(() => {
      if (!user.userData.selectedOrganizationId) return;
      (async () => {
         const response = await NotificationsService.listCategoriesTargets();
         const webhookCategories = response.data.filter(item => item.targetTypeId === `${NotificationTargetType.Webhook}`);
         setAllCategories(webhookCategories);
      })();
   }, [user.userData.selectedOrganizationId]);

   useEffect(() => {
      if (!allCategories.length) return;

      const left = buildTree(allCategories, categories, false);
      const right = buildTree(allCategories, categories, true);

      setInitialLeft(left);
      setInitialRight(right);
      setReady(true);

      if (onChangeList) onChangeList(flattenSelectedItems(right));
   }, [allCategories]);

   const handleChange = useCallback(
      (_leftTree, rightTree) => {
         if (onChangeList) onChangeList(flattenSelectedItems(rightTree));
      },
      [onChangeList]
   );

   if (!ready) return null;

   console.log(initialLeft);

   return (
      <DraggableDualList
         labelLeft="Categorias Disponíveis"
         labelRight="Categorias Selecionadas"
         initialLeft={initialLeft}
         initialRight={initialRight}
         onChange={handleChange}
      />
   );
}